export default __webpack_public_path__ + "static/media/line-circle-disclaimer.b3045b22.svg";